import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lightup',
  templateUrl: './lightup.component.html',
  styleUrls: ['./lightup.component.css']
})
export class LightupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
